export const MODEL_NAME = 'gpt-4o'

export const MINOR_LOCK_MESSAGE_ENGLISH =
  'Thank you for wanting to learn more about learning and thinking differences. Unfortunately, based on the information you have provided, you are not eligible to use the chat feature at this time. A parent, guardian, pediatrician, or school counselor can be helpful resources for answers, support, or next steps you need.'
